import { MNSproCloudApi } from '..';
import { AnalyzeRequest, AnalyzeResponse, ImportRequest } from '../api/v2';

class UserImportService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.DataImportApiFactory(config);

    return api;
  }

  static async analyze(
    authToken: string,
    organizationId: string,
    analyzeRequest: AnalyzeRequest,
  ): Promise<AnalyzeResponse> {
    const api = UserImportService.getApi(authToken);
    const response = await api.analyze(organizationId, analyzeRequest);

    return response.data;
  }

  static async import(
    authToken: string,
    organizationId: string,
    importRequest: ImportRequest,
  ) {
    const api = UserImportService.getApi(authToken);
    const response = await api._import(organizationId, importRequest);

    return response.data;
  }
}

export { UserImportService };
